import { Autocomplete, Box, Stack, TextField } from "@mui/material";
import {
  Dispatch,
  SetStateAction,
  memo,
  useEffect,
  useRef,
  useState,
} from "react";
import { useTranslation } from "react-i18next";

import {
  DatePickerUncontrolled,
  DateRangeSelect,
  ISelectType,
} from "@4uhub/lib4uhub";
import useFilter from "../../../hooks/useFilter";
import FiltersActions from "../../../components/FiltersActions/FiltersActions";

interface IMacroFilterProps {
  onFilterParams: Dispatch<SetStateAction<IFilterParams>>;
  filterParams: IFilterParams;
}

export interface IFilterParams {
  Status: string;
  InitialDate: Date | null;
  EndDate: Date | null;
  refresh?: Boolean;
}

const translationPath = "page.register.users.";

const UserMacroFilter: React.FC<IMacroFilterProps> = ({
  onFilterParams,
  filterParams,
}) => {
  const {
    // disableFilterBtn,
    filter,
    showCleanBtn,
    initialState,
    setFilter,
    cleanFilter,
  } = useFilter(filterParams);

  const { t } = useTranslation();

  const [enableFields, setEnableFields] = useState<boolean>(true);
  const [resetDateRange, setResetDateRange] = useState<boolean>(false);

  const isFirstRender = useRef(true);

  const selectPeriodOption: ISelectType = {
    id: "select_period",
    name: t(
      "Lib4uhub.components.date_range.select_period",
      "Selecionar período",
    ),
    value: "select_period",
  };

  const [dateRangeOption, setDateRangeOption] =
    useState<ISelectType>(selectPeriodOption);

  const handleStartDate = (date: Date | null) => {
    setFilter({ InitialDate: date });
  };
  const handleEndDate = (date: Date | null) => {
    setFilter({ EndDate: date });
  };

  const filterHandler = () => {
    onFilterParams(filter);
  };

  const cleanHandler = () => {
    onFilterParams(initialState.current);
    cleanFilter();
    setResetDateRange((prev) => !prev);
    setDateRangeOption(selectPeriodOption);
  };

  useEffect(() => {
    if (isFirstRender) {
      setFilter({ InitialDate: null, EndDate: null });
      onFilterParams({
        InitialDate: null,
        EndDate: null,
        Status: "",
        refresh: false,
      });
    }
    isFirstRender.current = false;
  }, [isFirstRender]);

  return (
    <Stack flexDirection={"row"} gap={2}>
      <Box sx={{ flex: "0 0 200px" }}>
        <DateRangeSelect
          setEndDate={handleEndDate}
          setStartDate={handleStartDate}
          setEnableFields={setEnableFields}
          resetToToday={resetDateRange}
          value={dateRangeOption}
          onValueSelected={(option) => {
            if (option) {
              setDateRangeOption(option);
            }
          }}
        />
      </Box>

      <Box sx={{ flex: "0 0 160px" }}>
        <DatePickerUncontrolled
          value={filter.InitialDate}
          onChange={(e) => setFilter({ InitialDate: e })}
          label={`${t(translationPath + "start_date")}`}
          isClearable={false}
          disable={enableFields}
        />
      </Box>
      <Box sx={{ flex: "0 0 160px" }}>
        <DatePickerUncontrolled
          value={filter.EndDate}
          onChange={(e) => setFilter({ EndDate: e })}
          label={`${t(translationPath + "end_date")}`}
          isClearable={false}
          disable={enableFields}
        />
      </Box>

      <Box sx={{ flex: "0 0 150px" }}>
        <Autocomplete
          getOptionLabel={(option) => option.name}
          size="small"
          onChange={(e, v) => {
            if (v) {
              setFilter({ Status: v.id });
            } else {
              setFilter({ Status: "" });
            }
          }}
          options={[
            {
              id: "true",
              name: t(translationPath + "actives"),
            },
            {
              id: "false",
              name: t(translationPath + "inactives"),
            },
          ]}
          renderInput={(params) => (
            <TextField {...params} label={"Status"} fullWidth />
          )}
        />
      </Box>

      <FiltersActions
        onFilter={filterHandler}
        onClean={cleanHandler}
        // disableFilterBtn={disableFilterBtn}
        showCleanBtn={showCleanBtn}
      />
    </Stack>
  );
};
export default memo(UserMacroFilter);
